export default {"src":"/_next/static/media/heritage-trees.f81955a5.svg","height":30,"width":28,"blurWidth":0,"blurHeight":0};